<template>
  <main class="p-4" v-if="home"  @click.prevent="changeSlide">
   
    <div class="sb-carousel" @mousemove="slideCursor" @mouseleave="$root.$emit('resetCursor')" v-hammer:swipe.horizontal="swipeSlide">
      <div class="track" :style="`transform: translateX(calc(${slide} * -100%))`" :class="{ timeout: timeout }">
        <div v-for="(img, index) in slides" :key="index">
          <img class="w-full h-screen object-cover" v-lazy="img.thumb" :data-srcset="img.srcset" alt="">
        </div>
      </div>
    </div>

    <div class="sb-carousel top">
      <div class="track" :style="`transform: translateX(calc(${opp} * -100%))`" :class="{ timeout: timeout }">
        <div v-for="(title, i) in slides" :key="i">
          <template v-if="i % 2 == 0">
            <h1 @click.self.stop="openSquadra" @mouseenter="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')" class="p-4 pt-6 md:pt-12 text-center">SQVADRA B</h1>
          </template>
          <template v-else>
            <h1 @click.self.stop="openFurniture" @mouseenter="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')" class="p-4 pt-6 md:pt-12 text-center">FVRNITURE</h1>
          </template>
        </div>
      </div>
    </div>

    
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "home",
  metaInfo() {
    return {
      title: this.site.title,
      titleTemplate: null,
    };
  },
  data() {
    return {
      slide: 0,
      opp: 0,
      timeout: false,
      autoplay: null,
    }
  },
  computed: {
    ...mapState(["site", "home"]),
    slides() {
      if(this.home && this.home.images) {
        return this.home.images.concat(this.home.images.concat(this.home.images));
      } else {
        return [];
      }
    },
    total() {
      if(this.home && this.home.images) {
        return this.home.images.length;
      } else {
        return 0;
      }
    },
    imgindex() {
      if(this.home && this.home.images) {
        return this.slide % this.total;
      } else {
        return 0;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.slide = this.total;
      this.opp = this.total + 1;
      this.autoplay = setInterval(this.nextSlide, 3000);
    }, 500);
  },
  methods: {
    slideCursor(event) {
      if(event.clientX < window.innerWidth / 2) {
        this.$root.$emit('changeCursor', '&#x25C0;');
      } else {
        this.$root.$emit('changeCursor', '&#x25B6;');
      }
    },
    changeSlide(event) {
      clearInterval(this.autoplay);
      if(event.clientX < window.innerWidth / 2) {
        this.prevSlide();
      } else {
        this.nextSlide();
      }
    },
    swipeSlide(event) {
      clearInterval(this.autoplay);
      if(event.direction == 2) {
            this.nextSlide();
      } else {
            this.prevSlide();
      }
    },
    nextSlide() {
      if(!this.timeout) {
        if(this.imgindex + 1 == this.total) {
          this.slide++;
          this.opp--;
           this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
              this.slide = this.total;
              this.opp = this.total + 1;
            }, 1000);
        } else {
          this.slide++;
          this.opp--;
           this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
            }, 1000);
        }
      }
    },
    prevSlide() {
      if(!this.timeout) {
        if(this.imgindex == 0) {
          this.slide--;
          this.opp++;
           this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
              this.slide = this.total + this.total - 1;
              this.opp = this.slide - 1;
            }, 1000);
        } else {
          this.slide--;
          this.opp++;
           this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
            }, 1000);
        }
      }
    },
    openFurniture() {
      this.$router.push({ name: 'furniture' });
    },
    openSquadra() {
      this.$router.push({ name: 'about' });
    }
  }
};
</script>
